import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { useCurrentSubscriptionQuery } from 'api';
import { Spinner } from 'components';
import { EmployeeFullDetails } from 'features/employeeDetails';
import { useAuth, useSubscription } from 'hooks';

import { CenteredRow, ContentW, PageW, Title } from './styled';

export function ProfilePage(): ReactElement {
  const { user } = useAuth();
  const { isTrial } = useSubscription();
  const { t } = useTranslation();

  useCurrentSubscriptionQuery();

  return (
    <PageW>
      <CenteredRow>
        <ContentW>
          {user && (
            <>
              <Title>{t('profile.title')}</Title>
              <div>{isTrial ? <Spinner /> : <EmployeeFullDetails employeeId={user.id} />}</div>
            </>
          )}
        </ContentW>
      </CenteredRow>
    </PageW>
  );
}
